import { useForm } from 'react-hook-form';
import { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { GetAllProduct, resetProductQRCode } from '../store/api/GetAllProduct';
import { addService, attachFile, loadFaultsByCustomer } from "../store/api/Services";
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { getCustomerInfo } from '../store/api/CustomerApi';
import QRCodeReader from "../Components/QRCode_Reader/QR_Reader";
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';
import barCodeImg from "../content/images/barcodeReader.png";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalProducts from "../Common/ModalProducts";
import ModalMap from "../Common/ModalMap";
import { Button, Row } from 'react-bootstrap';
import { FileMinus, GeoAltFill, List, PlusSquare } from 'react-bootstrap-icons';
const Service = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm();
    const [popMap, setMapPop] = useState({ show: false });
    const [isProvinceLoaded, setProvinceList] = useState(false);
    const [popQrCode, setPopQrCode] = useState({ show: false });
    const [popPorduct, setProductPopup] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState({ ProductID: -1, ProductName: "نامشخص", ProductModel: "نامشخص", HolderName: "تامشخص" });
    const { systemSettings, productDataQRCode, provinceList, cityList, zoneList, currentLocation, currentCustomer, isLoadingSaved, faultsByCustomer } = useSelector(state => {
        return {
            isLoadingSaved: state.loading?.isLoading,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            faultsByCustomer: state.service.faultsByCustomer,
            provinceList: state.locationDataReducer.provinceList,
            systemSettings: state.SystemSettingsReducer.systemSettings,
            currentLocation: state.locationDataReducer.currentLocation,
            currentCustomer: state.customerDataReducer.currentCustomer,
            productDataQRCode: state.customerDataReducer.productDataQRCode,
            serviceExtraAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettings,
        }
    });

    const settingNames = ['ProductGrouppingType', 'NationalCodeIsRequired', 'Services_SerialRequiredInCustomerRequest', "Services_ProductSerial_IsEnglish", "Services_AutoInvoiceForUsedparts", "Services_LocationRequiredInCustomerRequest"];
    const pgType = systemSettings && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const locationIsRequired = systemSettings?.find(s => s.SettingName === "Services_LocationRequiredInCustomerRequest")?.SettingValue?.toLowerCase() === "true";
    const serialIsRequired = systemSettings?.find(s => s.SettingName === "Services_SerialRequiredInCustomerRequest")?.SettingValue?.toLowerCase() === "true";
    const [otherInfoHeight, setOtherInfoHeight] = useState("2px");
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID));
    }
    const loadZoneList = (cityID) => {
        dispatch(getZoneList(cityID));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProvinces());
        dispatch(GetAllProduct());
        dispatch(getCustomerInfo());
        dispatch(resetProductQRCode());
        dispatch(loadFaultsByCustomer(""));

    }, []);
    useEffect(() => {
        setOtherInfoHeight((locationIsRequired || serialIsRequired) ? "auto" : "2px");
    }, [systemSettings])
    const provinceOnClick = () => {
        if (isProvinceLoaded)
            return;
        setProvinceList(true);

    }
    const history = useHistory();
    const onSubmit = (data) => {
        data.ProductId = Number(data.ProductId);
        data.Latitude = currentLocation?.lat;
        data.Longtitude = currentLocation?.lng;
        const onSuccess = (serviceID, serviceType) => {
            attachFile(document.getElementById("serviceAttach"), serviceID, serviceType);
            localStorage.setItem("now", Date.now());
            history.push("/LastRequest");
        }
        dispatch(addService(data, onSuccess))
    }

    function showModalProducts() {
        setProductPopup({
            show: true,
            setProductData: selectProduct
        })
    }
    function showModalMap() {
        setMapPop({ show: true });
    }
    function setHeight() {
        setOtherInfoHeight(otherInfoHeight === "auto" ? "2px" : "auto");
    }
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalProducts productGrouppingType={pgType} popData={popPorduct} setPopupData={setProductPopup} />
            {currentCustomer &&
                <ModalMap popData={popMap} setPopData={setMapPop} location={{ lat: !currentCustomer.Latitude || Number(currentCustomer.Latitude) === 0 ? 35.6996 : currentCustomer.Latitude, lng: !currentCustomer.Longtitude || Number(currentCustomer.Longtitude) === 0 ? 51.3380 : currentCustomer.Longtitude, zoom: 9 }} />
            }
            {!currentCustomer && <Loader type="BallTriangle" color="red" height={40} width={40} />}
            {currentCustomer &&
                <div className="card">
                    <div className="card-header headerStyle"> ثبت درخواست خدمات </div>
                    <div className="card-body bodyStyle">
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <button className="btn btn-default btn-block" type="button" onClick={() => setPopQrCode({ show: true })} style={{ padding: 0 }}><img src={barCodeImg} /></button>
                            {popQrCode.show && <QRCodeReader setProductData={selectProduct} setPopupData={setPopQrCode} />}
                            <div className='row'>
                                <div className="form-group col-md-3">
                                    <label> نوع سرویس </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                    <select className="form-control" name="ServiceType" ref={register({ required: true })} >
                                        <option value=""> لطفا انتخاب کنید </option>
                                        <option value="repair"> تعمیر </option>
                                        <option value="install"> نصب </option>
                                    </select>
                                    {errors.ServiceType && <small className="errors"> نوع سرویس را وارد کنید </small>}
                                </div>

                                <div className="form-group  col-md-3" style={{ position: "relative" }}>
                                    <label> توضیحات </label>
                                    {faultsByCustomer === "PENDING" &&
                                        <div className='form-control'>
                                            <Loader type="BallTriangle" color="#bb1370" width={20} height={20} />
                                        </div>
                                    }
                                    {faultsByCustomer && Array.isArray(faultsByCustomer) &&
                                        <Fragment>
                                            <input className="form-control" name="Attr7" ref={register({})} type="text" list='faultList' autoComplete='on' />
                                            <datalist id='faultList'>
                                                {faultsByCustomer.map((item, i) => <option key={i} value={item}>{item}</option>)}
                                            </datalist>
                                        </Fragment>
                                    }

                                </div>
                                <div className="form-group  col-md-3">
                                    <label> پیوست </label>
                                    <input id="serviceAttach" className="form-control" type="file" />
                                </div>
                            </div>
                            <Row className='rowBorder mt-3'>
                                <div className='rowTitle' onClick={setHeight} style={{ cursor: "pointer" }}>
                                    سایر اطلاعات{!serialIsRequired && !locationIsRequired && '(اطلاعات این بخش اختیاری است)'}
                                    &nbsp;
                                    {otherInfoHeight === "2px" && <PlusSquare size={17} className="hoverIcon" />}
                                    {otherInfoHeight === "auto" && <FileMinus size={17} />}
                                </div>
                                <Row style={{ height: otherInfoHeight ?? "2px", overflow: "hidden" }}>
                                    <div className="form-group col-md-3" >
                                        <label>{pgType === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                        <input type='hidden' name="ProductId" readOnly value={selectedProduct ? selectedProduct.ProductID : ""} ref={register({ required: true })} />
                                        <input type='text' className='form-control' readOnly
                                            value={selectedProduct && selectedProduct.ProductName ?
                                                (selectedProduct.HolderName && pgType !== 1 ? selectedProduct.HolderName + "-" : "") + selectedProduct.ProductName + '-' + selectedProduct.ProductModel : ""} />
                                        <Button className="btn-input-tiny"><List size={17} onClick={showModalProducts} /></Button>
                                        {errors.ProductId && <small className="errors"> نام محصول را وارد کنید </small>}
                                    </div>
                                    <div className="form-group col-md-3" >
                                        <label> شماره سریال </label>{(serialIsRequired) && <span style={{ color: "red" }}>*</span>}
                                        <input className="form-control" name="SerialNumber" ref={register({ required: (serialIsRequired) })} type="text" defaultValue={productDataQRCode && productDataQRCode.SerialNumber ? productDataQRCode.SerialNumber : ""} />
                                        {errors && errors.SerialNumber && <small className="errors"> سریال را وارد کنید </small>}
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام استان</label>{locationIsRequired && <span style={{ color: "red" }}>*</span>}
                                        {!isProvinceLoaded &&
                                            <select className="form-control" name="ProvinceID" onClick={() => provinceOnClick()} ref={register({ required: locationIsRequired })} readOnly value={currentCustomer?.ProvinceID ?? ""}>
                                                <option value={currentCustomer.ProvinceID}>{currentCustomer.ProvinceName}</option>
                                            </select>
                                        }
                                        {isProvinceLoaded &&
                                            <select className="form-control" name="ProvinceID" onChange={e => loadCityList(e.target.value)} ref={register({ required: locationIsRequired })} >
                                                <option value="">انتخاب کنید</option>
                                                {provinceList && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        }
                                        {errors.ProvinceID && <small className="errors">نام استان اجباری است</small>}

                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام شهر</label>{locationIsRequired && <span style={{ color: "red" }}>*</span>}
                                        {!isProvinceLoaded &&
                                            <select className="form-control" name="CityID" ref={register({ required: locationIsRequired })} readOnly value={currentCustomer?.CityID ?? ""}>
                                                <option value={currentCustomer.CityID}>{currentCustomer.CityName}</option>
                                            </select>
                                        }
                                        {isProvinceLoaded &&
                                            <select className="form-control" name="CityID" onChange={e => loadZoneList(e.target.value)} ref={register({ required: locationIsRequired })} >
                                                <option value="">انتخاب کنید</option>
                                                {cityList && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        }
                                        {errors.CityID && <small className="errors">نام شهر اجباری است</small>}
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نام منطقه</label>{locationIsRequired && <span style={{ color: "red" }}>*</span>}
                                        {!isProvinceLoaded &&
                                            <select className="form-control" name="ZoneID" ref={register({ required: locationIsRequired })} readOnly value={currentCustomer?.ZoneID ?? ""}>
                                                <option value={currentCustomer.ZoneID}>{currentCustomer.ZoneName}</option>
                                            </select>
                                        }
                                        {isProvinceLoaded &&
                                            <select className="form-control" name="ZoneID" ref={register({ required: locationIsRequired })}>
                                                <option value="">انتخاب کنید</option>
                                                {zoneList && zoneList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        }
                                        {errors.ZoneID && <small className="errors">منطقه جفرافیایی اجباری است</small>}
                                    </div>

                                    <div className="form-group  col-md-3">
                                        <label> آدرس محل مراجعه تکنسین </label>
                                        <input className="form-control" name="ServiceAddress" ref={register({})} type="text" defaultValue={currentCustomer ? currentCustomer.Address : ""} />
                                        {errors.ServiceAddress && <small className="errors"> آدرس اجباری است </small>}
                                        <Button className='btn-input-tiny' onClick={showModalMap}><GeoAltFill size={18} /></Button>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label> نام فروشگاه </label>
                                        <input className="form-control" name="ShopName" ref={register({})} type="text" />
                                    </div>
                                </Row>
                            </Row>
                            {!isLoadingSaved ? <button className="btn btn-primary btn-block w-100 mt-2">  ثبت درخواست  </button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="red" height={20} width={20} style={{ display: "inline-block" }} /> </span>}


                        </form>
                    </div>
                </div>

            }
        </div>
    )
}
export default Service;
